export const OptionsEnum = {
  Yes: "Yes",
  No: "No",
  Tax_Resident_Of_countries_Other_Than_Us:
    "I am tax resident of countries other than US/CANADA",
  Tax_Resident_Of_India_Only: "I am tax resident of India only",
  Tax_Resident_Of_Us_Or_Canada: "I am tax resident of US or CANADA",
  Resident: "Resident",
  Non_Resident: "Non-Resident",
  Non_Resident_Indian: "Non-Resident Indian",
  OCI_Card_Holder: "OCI Card Holder",
  Non_Resident_Others: "Non-Resident – Others",
};
